export enum StorageBoxLoadedTypeEnum {
  LIFTVAN = "Liftvan",
}
